import { ConfigState } from '@interfaces';

export const configInitialState: ConfigState = {
  timezones: {
    data: null,
    isLoading: false,
    error: null,
  },
};
